import Vue from 'vue'
import App from './App.vue'
// window.log = console.log;
Vue.config.productionTip = false;
import 'material-design-icons-iconfont/dist/material-design-icons.css'


import VueRouter from 'vue-router'
import UploadSendi from './components/UploadSendi.vue'
import UploadMendi from './components/UploadMendi.vue'

import Screen from './components/Screen.vue'
import Login from './components/Login.vue'
import Home from './components/Home.vue'
import SearchTable from './components/SearchTable.vue'
import MendiStatistics from './components/MendiStatistics.vue'
import SendiSettings from './components/SendiSettings.vue'
import StyleBuilder from './components/StyleBuilder.vue'
import ButtonBuilder from './components/ButtonBuilder.vue'
import Whatsapp from './components/Whatsapp.vue'
import SmsBuilder from './components/SmsBuilder.vue'
import Settings from './components/Settings.vue'
import Insert from './components/Insert.vue'
import EnteringValues from './components/EnteringValues.vue'
// import ScreenBuilderStyle from './components/ScreenBuilderStyle.vue'
import ScreenBuilder from './components/ScreenBuilder.vue'


const ENV = require('./../.env');
// console.log(ENV)

Vue.prototype.$ENV = ENV;
// dev
// Vue.prototype.$server_url = ENV.server_url + ':' + ENV.http_port;
// Vue.prototype.$server_api_url = ENV.server_url + ':' + ENV.http_port;
// prod
Vue.prototype.$server_url = ENV.server_url /*+ ':' + ENV.http_port*/;
Vue.prototype.$server_api_url = ENV.server_url /*+ ':' + ENV.http_port*/;
console.log('Vue.prototype.$server_url', Vue.prototype.$server_url)
console.log('Vue.prototype.$server_api_url', Vue.prototype.$server_api_url)
Vue.prototype.$user = {};

const routes = [
    { path: '*'                  , redirect: 'home'                                              },
    { name: 'home'               , path: '/home'                 , component: Home               },

    { name: 'sendi-upload'       , path: '/sendi/upload'         , component: UploadSendi        },

    // {name: 'screen-style'       , path: '/screen/style'         , component: ScreenBuilderStyle },
    { name: 'screen-builder'     , path: '/screen/settings'      , component: ScreenBuilder      },
    { name: 'screen-style'       , path: '/screen/style'         , component: StyleBuilder       },
    { name: 'screen-buttons'     , path: '/screen/buttons'       , component: ButtonBuilder      },
    { name: 'screen'             , path: '/screen/:code'         , component: Screen             },

    { name: 'mendi-upload'       , path: '/mendi/upload'         , component: UploadMendi        },
    { name: 'mendi-search'       , path: '/mendi/search'         , component: SearchTable        },
    { name: 'mendi-statistics'   , path: '/mendi/statistics'     , component: MendiStatistics    },
    { name: 'sendi-settings'     , path: '/sendi/settings'       , component: SendiSettings      },
    { name: 'sms-settings'       , path: '/sms/settings'         , component: SmsBuilder         },
    { name: 'insert'             , path: '/insert'               , component: Insert             },
    { name: 'entering-values'    , path: '/entering-values'      , component: EnteringValues     },
    { name: 'whatsapp'           , path: '/whatsapp'             , component: Whatsapp           },

    { name: 'settings'           , path: '/system/settings'      , component: Settings           },

    { name: 'login'              , path: '/login'                , component: Login              },
];
import axios from 'axios';

const router = new VueRouter({ base: '/app/', mode: 'history', routes});

router.beforeResolve((to, from, next) => {
    if(to.name == 'login') {
        next();
    }
    else {
        return axios.get(Vue.prototype.$server_api_url + `/api/v1/user/curr`)
            .then(response => {
                if(+response.data.err !== 0) {
                    // console.log(response)
                    // alert(response.data.err)
                    router.replace('login');
                }
                else {
                    Vue.prototype.$user = response.data.entity;
                    next();
                }
            }).catch(e=>alert(e));
    }
});



require('vuetify/dist/vuetify.min.css');
import Vuetify from 'vuetify'
Vue.use(Vuetify);
Vue.use(VueRouter);



const q = require('q');
// import VueSocketio from 'vue-socket.io';
// Vue.use(VueSocketio, Vue.prototype.$server_url + ":9767");
import socketio from 'socket.io-client';

// dev
// /*export*/ const SocketInstance = socketio(ENV.server_url + ":" + ENV.ws_port, { /*secure: !!ENV.is_production,*/ /*rejectUnauthorized: false*/ });
// prod
/*export*/ const SocketInstance = socketio(ENV.ws_port, { /*secure: !!ENV.is_production,*/ /*rejectUnauthorized: false*/ });

let patch = require('socketio-wildcard')(socketio.Manager);
patch(SocketInstance);
// Vue.use(VueSocketio, SocketInstance);
Vue.prototype.$socket = SocketInstance;

function rand(min, max) {
    return parseInt(Math.random() * (max  - min  + 1) + min);
}

const moment = require('moment-timezone');
Vue.prototype.$socketRequests = {};

Vue.prototype.$socket.req = function (channel, data = {}) {
    let $uniqid = moment().valueOf() + '_' + rand(1000, 9999);
    Vue.prototype.$socketRequests[$uniqid] = {
        channel: channel,
        deferred: q.defer(),
        timeout : setTimeout(() => {
            // console.warn("Request timed out - $uniqid:", $uniqid, 'channel:', channel, '!!')
            Vue.prototype.$socketRequests[$uniqid].deferred.reject("Request timed out, " + channel);
            delete Vue.prototype.$socketRequests[$uniqid];
        }, 10000)
    };

    data = Object.assign(data, {$uniqid : $uniqid});
    // log('req =>', Vue.prototype.$socketRequests[uniqid].channel);
    Vue.prototype.$socket.emit(channel, data);
    return Vue.prototype.$socketRequests[$uniqid].deferred.promise;
};
Vue.prototype.$socket.res = function(data) {
    // log('res <=', Vue.prototype.$socketRequests[uniqid].channel);
    if (Vue.prototype.$socketRequests[data.$uniqid]) {
        clearTimeout(Vue.prototype.$socketRequests[data.$uniqid].timeout);
        return Vue.prototype.$socketRequests[data.$uniqid].deferred.resolve(data);
    }
    //log("No $uniqid", data.$uniqid, "request!");
}

new Vue({
    router,
  render: h => h(App)
}).$mount('#app')
